export interface ImageToVideoExample {
  name: string;
  prompt: string;
  firstFrameURL: string;
  endFrameURL: string | null;
  coverPageURL: string;
  resourceURL: string | null;
  // Note: asset_id fields removed as we now use URL-based approach
  // The backend will handle URL processing directly via ref_images_url and tail_image_url
}

export const IMAGE_TO_VIDEO_EXAMPLES: ImageToVideoExample[] = [
  {
    name: '男生与狗狗亲昵',
    prompt:
      '真实拍摄风格，使用高清莱卡相机拍摄。近景镜头，男生微微低头贴近狗狗，狗狗轻嗅他的脸，动作自然亲昵。镜头缓慢推进，捕捉他们之间的情感细节。微风轻拂，男生的发丝、狗狗柔软的毛发，以及背景盛开的花朵轻轻摇曳，形成轻盈律动感。阳光柔和，从侧后方洒下，勾勒出人物和狗狗的轮廓光。远处天际的云层被风吹动，缓缓飘远，为画面增添时间流动的诗意。整个画面温暖、宁静，充满真实情感。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/1.png',
    endFrameURL: null,
    coverPageURL: 'https://cdn.jme-aigc.com/examples/1.png',
    resourceURL: null,
  },
  {
    name: '神秘的火山岩浆',
    prompt:
      '赛博朋克，细腻柔和、富有诗意。镜头缓慢推进，一片静谧山谷中，岩浆如光滑的橙红丝带，缓缓沿山体蜿蜒而下，表面跳动着温柔的火光。天空飘落晶莹雪花，点点洒落在尚未凝固的岩面上，发出轻微“嘶”的声响，随即蒸腾起缥缈白雾，宛如温热的叹息。热气轻轻升起，在空中缓缓扭动，和雪花一同被风带动。镜头继续推进，焦点渐渐靠近岩浆与雪花交汇处，背景是缓慢移动的云朵与被微光照亮的山峦，色调柔和，富有生命气息。整个画面如同一幅缓缓展开的童话风景，既温暖又神秘。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/2_first.png',
    endFrameURL: 'https://cdn.jme-aigc.com/examples/2_end.png',
    coverPageURL: 'https://cdn.jme-aigc.com/examples/2_first.png',
    resourceURL: null,
  },
  {
    name: '真实女孩肖像',
    prompt:
      '一张17岁女孩的肖像，粉红色的嘴唇和深棕色的刘海。这个女孩有一双大眼睛，反映出她的天真无邪，鼻子上有微妙的雀斑。她的皮肤光滑，增添了她的整体魅力。这张照片是川内凛子的风格。它应该具有非常逼真的纹理，类似于真实的照片。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/3.png',
    endFrameURL: null,
    coverPageURL: 'https://cdn.jme-aigc.com/examples/3.png',
    resourceURL: null,
  },
  {
    name: '小松鼠在山间小溪喝水',
    prompt:
      '清晨微光洒落，山间小溪在林间蜿蜒缓缓流动，水面映出斑驳树影与天光。画面为动画电影风格，温暖柔和，色彩通透。镜头从高处缓慢下移至近景，一只毛茸茸的小松鼠跳跃至溪边，低头饮水，动作轻巧灵动。水面微微荡漾，倒映出它的身影与头顶飘落的树叶。远处林中有微风拂动枝叶，鸟鸣隐约传来，营造宁静自然氛围。光线从侧后方洒入，为松鼠和溪水勾勒出柔和边缘光。镜头推进至松鼠侧脸特写，它警觉地抬头，眼神清澈好奇。整段画面犹如一幅温柔诗意的童话，充满宫崎骏式的自然美与生命气息。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/4_first.png',
    endFrameURL: 'https://cdn.jme-aigc.com/examples/4_end.png',
    coverPageURL: 'https://cdn.jme-aigc.com/examples/4_first.png',
    resourceURL: null,
  },
  {
    name: '小男孩变形成狼',
    prompt: '小男孩低头，抬头时，身体变形，毛发膨胀，变身成为狼，镜头拉远',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/5_first.png',
    endFrameURL: 'https://cdn.jme-aigc.com/examples/5_end.png',
    coverPageURL: 'https://cdn.jme-aigc.com/examples/5_first.png',
    resourceURL: null,
  },
  {
    name: '月季花自然高清摄影',
    prompt:
      '一盆盛放的粉红色月季栽种在复古原木色木盆中，月季花长得旺盛，月季的枝丫和花盆有完美的比例。晨露凝结在娇嫩花瓣边缘，木盆表面带有天然木纹，背景虚化为葱郁绿叶与柔和晨光，自然光线均匀洒落，写实风格高清摄影。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/6.png',
    endFrameURL: null,
    coverPageURL: 'https://cdn.jme-aigc.com/examples/6.png',
    resourceURL: null,
  },
  {
    name: '梦幻蝴蝶飞舞',
    prompt:
      '蝴蝶翅膀如自适应极光火焰，变色粒子随观众动作而变化，静止时如日落珊瑚，运动时如未来黄昏',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/7_first.png',
    endFrameURL: 'https://cdn.jme-aigc.com/examples/7_end.png',
    coverPageURL: 'https://cdn.jme-aigc.com/examples/7_first.png',
    resourceURL: null,
  },
  {
    name: '宁静的茶具',
    prompt:
      '茶文化，一种宁静祥和的氛围弥漫在这张精致的照片中，捕捉到了无光泽户外环境的精髓。一张做工精美的木桌，其深色、浓郁的色调让人联想到古老的木材，是中心焦点，位于传统日本幕府屏风的柔和格子之下。桌子的表面装饰着一些精心挑选的物品，散发出一种低调的优雅。一个精致的手工陶瓷花瓶，其深色哑光的表面在微妙的精致中堪称一流，坐在桌子上，细长的颈部支撑着几片细长的祖母绿竹叶。花瓶低调的存在证明了克制之美，让周围树叶的自然之美成为中心舞台。这是因为。附近，第二个同样制作的花瓶，其深色、光滑的设计完美地衬托了花瓶更质朴的魅力，有几片细长的淡绿色叶子，它们精致的卷须伸向了光线相似的笔触。这两个容器的并置，每一个都是一个精湛的练习，创造了一种和谐与平衡的感觉，是自然与人类创造之间和谐的视觉表现。桌子上放着一个精致的小茶壶，它的深色、奶油色与周围的装饰完美搭配，旁边放着一只精致的小杯子，它的淡金色是对周围环境之美的微妙致敬。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/8.png',
    endFrameURL: null,
    coverPageURL: 'https://cdn.jme-aigc.com/examples/8.png',
    resourceURL: null,
  },
  {
    name: '清澈的溪水',
    prompt:
      '在这幅特写镜头中，清澈的溪水在阳光的照射下泛着粼粼波光，水流轻柔地滑过覆盖着青苔的岩石，形成了一道细腻的小瀑布。画面中的每一滴水珠都清晰可见，它们在阳光下闪烁，仿佛是大自然的珍珠。周围的植被郁郁郁葱葱，为这幅画面增添了一抹生机勃勃的绿色。这幅特写镜头捕捉了水流的动态美，展现了自然界中不断变化的生命力，同时也传递出一种清新宁静的氛围，让人仿佛置身于一个远离尘嚣的世外桃源。',
    firstFrameURL: 'https://cdn.jme-aigc.com/examples/9.png',
    endFrameURL: null,
    coverPageURL: 'https://cdn.jme-aigc.com/examples/9.png',
    resourceURL: null,
  },
];
